import RollingImage from "components/images/RollingImage";

import styles from "components/event/EventDetailComponentWideProductCard.module.scss";
import TruncateMarkup from "react-truncate-markup";
import classNames from "classnames";
import utilStyles from "styles/utils.module.scss";
import {numberWithComma} from "common/utils";
import Link from "next/link";
import {productsRoute} from "common/const";
import RightArrowIcon from "images/icons/arrow_right_black_16.svg";
import PouchIcon from "images/icons/add_to_pouch.svg";
import addOptionCountsToPouch from "api/addToPouch";
import OptionSelectorModal from "components/modal/OptionSelectorModal";
import {toast} from "react-toastify";
import {useContext} from "react";
import ToastContext from "context/ToastContext";
import PouchContext from "context/PouchContext";
import ModalContext from "context/ModalContext";
import UserContext from "context/AuthContext";
import {useCouponDiscountedPrice} from "hooks/useCouponDiscountedPrice";

const EventDetailComponentWideProductCard = (props) => {
    const {product, productOption} = props;

    const productLink = (
        product.override_link ?
            product.override_link :
            `${productsRoute}/${product.id}`
    );

    const brandName = product.brand.name;
    const isDiscounted = productOption ? productOption.price !== productOption.discounted_price : product.price !== product.discounted_price;
    const maxLine = 2;
    const optionName = productOption.name;

    const {openModal, closeModal} = useContext(ModalContext) || {};
    const toastContext = useContext(ToastContext);
    const pouchContext = useContext(PouchContext);
    const user = useContext(UserContext).user;

    const handleCloseOptionSelectorModal = () => {
        closeModal();
    };

    const onAddToPouchSuccessOverride = () => {
        const toastId = toast.info(
            '장바구니에 제품을 담았어요',
        );
        toastContext.registerToast(toastId);
        closeModal();
    };

    const addToPouch = (e) => {
        e.stopPropagation();
        e.preventDefault();
        toastContext.closeToast();
        const options = product.options;
        if (options.length === 1) {
            const [referralId, referralPostId] = [null, null];
            const pouchOptions = [
                {
                    option_id: parseInt(options[0].id),
                    count: 1,
                    referral_id: referralId,
                    referral_post_id: referralPostId,
                    price: options[0].discounted_price
                }
            ];
            addOptionCountsToPouch(pouchOptions, user != null, onAddToPouchSuccessOverride, pouchContext,
                false, product.id, product.name);
        } else {
            openModal(() => {
                return <OptionSelectorModal
                    product={product} isModalOpen={true}
                    close={handleCloseOptionSelectorModal}
                    buttonText={"장바구니 담기"}
                    onAddToPouchSuccessOverride={onAddToPouchSuccessOverride}
                    isPouchForced
                />
            });
        }
    };

    const {discountedPriceText, discountRate} = useCouponDiscountedPrice(product, true);
    const finalPriceText = product.is_entered ? discountedPriceText : '미입점';

    return (
        <Link href={productLink} shallow={false} scroll={false}>
            <div className={styles.root}>
                <div className={styles.image}>
                    <RollingImage prefix={"product_images"} images={product?.thumbnail_urls}/>
                    <div className={styles.pouchButton} onClick={addToPouch}>
                        <PouchIcon width="24" height="24" viewBox="0 0 30 30" />
                    </div>
                </div>
                <div className={styles.productInfo}>
                    <div>
                        <div className={styles.brandSection}>
                            <span className={styles.brand}>{brandName}</span>
                        </div>
                        <TruncateMarkup lines={maxLine} ellipsis={<span>...</span>}>
                            <div className={styles.name}>
                                {product.name}
                            </div>
                        </TruncateMarkup>
                        <TruncateMarkup lines={maxLine} ellipsis={<span>...</span>}>
                            <div className={styles.optionName}>
                                {optionName}
                            </div>
                        </TruncateMarkup>
                    </div>
                    <div>
                        <div className={classNames(styles.itemContainer, utilStyles.relative)}>
                            <div className={styles.itemPriceContainer}>
                                {isDiscounted &&
                                    <div className={styles.originalPriceContainer}>
                                        <span className={styles.originalPrice}>{numberWithComma(product.price)}</span>
                                    </div>
                                }
                                <div className={styles.discountedPriceContainer}>
                                    {
                                        isDiscounted &&
                                        <>
                                            <span className={styles.discount}>{discountRate}</span>
                                            <span className={styles.percentage}>%</span>
                                        </>
                                    }
                                    <span className={styles.price}>{finalPriceText}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.buttonContainer}>
                    <RightArrowIcon viewBox="0 0 16 16" className={styles.rightArrowIcon}/>
                </div>
            </div>
        </Link>
    )
};

export default EventDetailComponentWideProductCard;
